// extracted by mini-css-extract-plugin
export default {"chat_notification":"chatNotification_chat_notification__Zk+wF","count":"chatNotification_count__zjQkg"};